import type { HelpFile } from '../../types/help'
import { CertificationReviewsTestIds } from '../../../testids/CertificationReviewsTestIds'

export const certificationReviewsHelp: HelpFile = {
  docPage: '/docs/governance/certification-reviews',
  texts: {
    [CertificationReviewsTestIds.reviewMasterDetail]:
      'Zugewiesene Prüfpositionen — für jede Zuweisung entscheiden, ob der Zugriff behalten oder entzogen werden soll.',
    [CertificationReviewsTestIds.reviewLeftPanel]: null,
    [CertificationReviewsTestIds.reviewRightPanel]: null,
    [CertificationReviewsTestIds.reviewItemsCount]: null,
    [CertificationReviewsTestIds.reviewProgress]:
      'Bereits entschiedene Prüfpositionen im Verhältnis zur Gesamtzahl der offenen.',
    [CertificationReviewsTestIds.statDecided]: null,
    [CertificationReviewsTestIds.campaignQuickFilter]:
      'Prüfwarteschlange auf eine bestimmte Zertifizierungskampagne einschränken.',
    [CertificationReviewsTestIds.colExpand]: null,
    [CertificationReviewsTestIds.colIdentity]: null,
    [CertificationReviewsTestIds.colStatus]: null,
    [CertificationReviewsTestIds.colDecidedAssignments]:
      'Bereits entschiedene Zuweisungen für diese Identität innerhalb der Kampagne.',
    [CertificationReviewsTestIds.btnBulkCertify]:
      'Alle ausgewählten Prüfpositionen auf einmal zertifizieren — bestätigt, dass der Zugriff für alle gültig bleibt.',
    [CertificationReviewsTestIds.btnCertifyItem]: null,
    [CertificationReviewsTestIds.btnReassignItem]: null,
    [CertificationReviewsTestIds.btnReviewAssignments]:
      'Zuweisungs-Review-Ansicht für die ausgewählte Identität öffnen.',
    [CertificationReviewsTestIds.reviewDetailName]: null,
    [CertificationReviewsTestIds.reviewDetailReviewer]:
      'Die für die Entscheidung über diesen Zugriff verantwortliche Person — üblicherweise die Führungskraft der Identität oder ein delegierter Prüfer.',
    [CertificationReviewsTestIds.reviewDetailCampaign]:
      'Die Zertifizierungskampagne, zu der diese Prüfposition gehört.',
  },
}
